module.exports = __webpack_public_path__ + "img/experience-bg.b2e7215e.jpg";